/* eslint-disable  no-plusplus */
import { useState } from 'react'

import TableHeaderItem from './TableHeaderItem'

const buildArray = length => {
  const a = []
  for (let i = 0; i < length; i++) {
    a.push(true)
  }
  return a
}

const TableHeader = ({ isShowRequire, headers, onSortChange, ExpandedRowRender, data, loading, indent, ...rest }) => {
  const [currentSort, setCurrentSort] = useState({ name: undefined, order: 'UP' })
  return (
    <thead>
      <tr {...rest}>
        {ExpandedRowRender && <TableHeaderItem style={{ width: '40px' }} key="expandedRowRender" />}
        {/** biome-ignore lint/suspicious/noArrayIndexKey: TODO */}
        {indent > 0 && buildArray(indent).map((_, i) => <TableHeaderItem key={i} />)}
        {headers
          .filter(header => !header.isHiddenColumn && !header.isExportOnly)
          .map((header, i) => (
            <TableHeaderItem
              onSortChange={order => {
                onSortChange(header.name, order)
                setCurrentSort({ name: header.name, order })
              }}
              // eslint-disable-next-line react/no-array-index-key
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO
              key={i}
              isShowRequire
              data={data}
              loading={loading}
              sortOrder={header.name === currentSort.name ? currentSort.order : 'DEFAULT'}
              {...header}
            />
          ))}
      </tr>
    </thead>
  )
}

TableHeader.defaultProps = {
  headers: [],
  isShowRequire: false,
  onSortChange: () => {},
}

export default TableHeader
